import React, { useEffect, useState } from "react";
import { Container, Form } from "reactstrap";
// Formik validation
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useHistory, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import { editEmployee, getEmployee } from "../../../api/employees";
import FormButtonHandler from "../../../components/FormButtonHandler";
import useCustomValidation from "../validationSchema";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { useGetInstence } from "../../../hooks/useGetInstence";
import EmployeeForm from "./EmployeeForm";
import FIELDS, { REQUIRED_FIELDS } from "./CONSTANT";
import * as Yup from "yup";

const TYPES = {
  select: null,
  "add-more": [],
  checkbox: false,
  file: null,
};

const initialValues = {};
const FIELDS_VALIDATION = {};

FIELDS.forEach((f) => {
  initialValues[f.key] = TYPES[f.type] || "";
});

REQUIRED_FIELDS.forEach((f) => {
  if (f.type == "file") {
    FIELDS_VALIDATION[f.key + "_preview"] = Yup.string().required(
      "This Field Is Required"
    );
  } else if (f.type == "select" && f.isMulti) {
    FIELDS_VALIDATION[f.key] = Yup.array();
  } else {
    FIELDS_VALIDATION[f.key] = Yup.string().required("This Field Is Required");
  }
});

const EditEmployee = () => {
  let navigate = useHistory();
  const { employeeSchema } = useCustomValidation();

  const { t } = useTranslation();

  const params = useParams();
  const [editedEmployee, setEditedEmployee] = useState(null);

  const { instenceLoading, instenceError, instenceSuccess } = useGetInstence(
    getEmployee,
    params.id,
    (response) => {
      delete response.data.data.employee.pools;
      setEditedEmployee({
        ...response.data.data.employee,
        id_front_side_preview: response.data.data.employee.id_front_side,
        id_front_side: null,
        id_back_side_preview: response.data.data.employee.id_back_side,
        id_back_side: null,
      });
    }
  );

  const { setData, loading, error, success } = useResponse(editEmployee, () => {
    navigate.goBack();
  });

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      ...editedEmployee,
    },
    validationSchema: Yup.object(FIELDS_VALIDATION),
    onSubmit: (values) => {
      let data = new FormData();
      Object.keys(values).map((key) => {
        if (values[key]) {
          data.append(key, values[key]);
        }
      });
      setData({ type: "edit", id: params.id, data });
    },
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={t("Employees")}
            breadcrumbItem={t("btns.Edit") + " " + t("Employee")}
          />

          {editedEmployee && (
            <Form
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <EmployeeForm validation={validation} />

              <FormButtonHandler btnTxt="Edit" loading={loading} />
            </Form>
          )}

          <ResultHandler
            loading={instenceLoading}
            error={error}
            success={success}
            successMsg={"Updated Successfully!"}
          />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EditEmployee;
